import { Color, Flex, Spacing, Text } from '@billy/design-system'
import { ReactElement, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useSalesReportStatistics } from '../../../../contexts/salesReportStatisticsContext'
import { SalesReportGraphBucket } from '../../../../enums/salesReportGraphBucket'
import { SalesReportStatisticsVariant } from '../../../../types/salesReportStatisticsVariant'
import { SalesReportColorBox } from '../SalesReportColorBox'

export const SalesReportGraphHeader = (): ReactElement => {
  const { t } = useTranslation()
  const { graphBucket, shouldShowUnpaid, variant } = useSalesReportStatistics()

  const overviewGraphHeaderTitle = useMemo(
    () =>
      ({
        [SalesReportGraphBucket.Day]: t('sales_report.sales_overview.statistics.graph.title_day'),
        [SalesReportGraphBucket.Month]: t('sales_report.sales_overview.statistics.graph.title_month'),
        [SalesReportGraphBucket.Week]: t('sales_report.sales_overview.statistics.graph.title_week'),
      })[graphBucket ?? SalesReportGraphBucket.Month],
    [graphBucket, t],
  )

  const graphHeaderTitle: Record<SalesReportStatisticsVariant, string> = useMemo(
    () => ({
      overview: overviewGraphHeaderTitle,
      'by-customer': t('sales_report.sales_by_customer.statistics.graph.title'),
      'by-item': t('sales_report.sales_by_item.statistics.graph.title'),
    }),
    [overviewGraphHeaderTitle, t],
  )

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Text variant="h2" weight="regular">
        {graphHeaderTitle[variant]}
      </Text>
      <Flex alignItems="center" gap={Spacing.S16} justifyContent="flex-end">
        <SalesReportColorBox alignItems="center" color={Color.Green400}>
          <Text variant="bodySM">{t('sales_report.statistics.graph.invoices.paid')}</Text>
        </SalesReportColorBox>
        {shouldShowUnpaid && (
          <SalesReportColorBox alignItems="center" color={Color.Grey200}>
            <Text variant="bodySM" colorVariant="secondary">
              {t('sales_report.statistics.graph.invoices.unpaid')}
            </Text>
          </SalesReportColorBox>
        )}
      </Flex>
    </Flex>
  )
}
